export default "__VITE_ASSET__BFG39DaZ__"